import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './OrderSuccess.css';

const OrderSuccess = () => {
  const { state } = useLocation();
  const navigate  = useNavigate();
  const orderId   = state?.orderId || 'ATR-' + Date.now();
  const payMethod = state?.paymentMethod || 'online';
  const paymentId = state?.paymentId || null;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="os-root">
      <div className="os-card">
        {/* Success animation */}
        <div className="os-tick-wrap">
          <div className="os-tick-circle">
            <svg viewBox="0 0 52 52" className="os-tick-svg">
              <circle className="os-tick-ring" cx="26" cy="26" r="25" fill="none" strokeWidth="2" />
              <path  className="os-tick-check" fill="none" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" d="M14 26l9 9 16-16" />
            </svg>
          </div>
        </div>

        <h1 className="os-title">Order Confirmed!</h1>
        <p className="os-sub">Thank you for shopping with ATR Agro Mart 🌿</p>

        <div className="os-order-id">
          Order ID: <strong>{orderId}</strong>
        </div>

        {paymentId && (
          <div className="os-payment-id">
            Payment ID: <span>{paymentId}</span>
          </div>
        )}

        <div className="os-info-cards">
          <div className="os-info-card">
            <span className="os-info-icon">📦</span>
            <div>
              <strong>Order Placed</strong>
              <p>We've received your order</p>
            </div>
          </div>
          <div className="os-info-card">
            <span className="os-info-icon">{payMethod === 'cod' ? '💵' : '✅'}</span>
            <div>
              <strong>{payMethod === 'cod' ? 'Pay on Delivery' : 'Payment Successful'}</strong>
              <p>{payMethod === 'cod' ? 'Pay when your order arrives' : 'Your payment is confirmed'}</p>
            </div>
          </div>
          <div className="os-info-card">
            <span className="os-info-icon">🚚</span>
            <div>
              <strong>Estimated Delivery</strong>
              <p>2–5 business days</p>
            </div>
          </div>
        </div>

        <div className="os-actions">
          <button className="os-btn-primary" onClick={() => navigate('/orders')}>
            Track My Order
          </button>
          <button className="os-btn-secondary" onClick={() => navigate('/agro')}>
            Continue Shopping
          </button>
        </div>
      </div>
    </div>
  );
};

export default OrderSuccess;